import { render } from "./InternalLBAssignVmForm.vue?vue&type=template&id=767f317e&scoped=true"
import script from "./InternalLBAssignVmForm.vue?vue&type=script&lang=js"
export * from "./InternalLBAssignVmForm.vue?vue&type=script&lang=js"

import "./InternalLBAssignVmForm.vue?vue&type=style&index=0&id=767f317e&lang=scss&scoped=true"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767f317e"]])

export default __exports__